module.exports = __webpack_public_path__ + "assets/mail.915db0d4.svg";